import { filterResponse, serverFetch } from '../api'
import type { Settings } from '../types/settings'

export const getSettings = async (): Promise<Settings | null> => {
  const req = await serverFetch<Settings>('/settings')
  return filterResponse(req)
}
